import { resolveComponentVariant } from '../componentContract'
import styles from '../../boardui/Navigation.module.css'

/**
 * A small set of exclusive options. An item with `unavailable` stays focusable and announced as disabled
 * (aria-disabled) but never selects: activating it calls its `onUnavailable` instead, so the caller can point at
 * the reason, which `describedBy` names. `disabled` removes the item from use altogether.
 */
export function SegmentedControl({ items = [], value, onValueChange, label = 'View options', className = '' }) {
  if (items.length > 4) resolveComponentVariant('SegmentedControl item count', items.length, [0, 1, 2, 3, 4], 4)

  return (
    <div className={`${styles.segmented} ${className}`.trim()} role="group" aria-label={label}>
      {items.map((item) => {
        const itemValue = item.value ?? item.key
        return (
          <button
            key={itemValue}
            type="button"
            className={styles.segment}
            aria-pressed={itemValue === value}
            aria-disabled={item.unavailable ? 'true' : undefined}
            aria-describedby={item.describedBy}
            disabled={item.disabled}
            onClick={() => (item.unavailable ? item.onUnavailable?.(itemValue) : onValueChange?.(itemValue))}
          >
            {item.label}
          </button>
        )
      })}
    </div>
  )
}
